const fonts = {
  heading: 'Avenir, Arial, sans-serif',
  body: 'Avenir-Roman, Arial, sans-serif',
};

export default fonts;
